export {PointsMapView} from "./property-map.view";
export {PointsMap, type PointsMapInstance} from "./property-map.model";
